import {getInterestsByIndustry} from "@/api/list";
import {IList} from "@/interfaces";
import {useEffect, useState} from "react";

export const useInterestByIndustryList = (industry: number) => {
	const [interestList, setInterestList] = useState<IList[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		setLoading(true);
		getInterestsByIndustry(industry)
			.then((response) => {
				setInterestList(response.data);
				setError(null);
			})
			.catch((err) => {
				setError(err);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [industry]);

	return {interestList, loading, error};
}
